import { ReactElement } from "react";

import { FilterAddButton, FilterClearButton, FiltersApply } from "./";
import {
  FilterActionsDividerStyled,
  FilterActionsStyled,
} from "./actions.styled";

export const FiltersActionsApply = (): ReactElement => {
  return (
    <FilterActionsStyled>
      <FilterAddButton />
      <FilterActionsDividerStyled />
      <FilterClearButton />
      <FilterActionsDividerStyled />
      <FiltersApply />
    </FilterActionsStyled>
  );
};
